import React, { useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { DATE_FORMATS } from "@constants/date-formats.constants";

const HubSpotForm = () => {
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.content.create({
        region: "na1",
        portalId: "47212632",
        embedId: "182432056907",
        elementId: "hs-embed-182432056907-wi4pb8"
      })
    }
  }, []);

  return <div id="hs-embed-182432056907-wi4pb8"></div>;
};

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="logo-social-link">
          <a href="#">
            <img src="../assets/images/logo.svg" className="footer-logo img-fluid" alt="Icon" />
          </a>
          <ul>
            <li>
              <Link to="http://tiktok.com/@caterplace" target="_blank">
                <img src="../assets/images/icon-tiktok.png" width={40} className="img-fluid" alt="Icon" />
              </Link>
            </li>
            <li>
              <Link to="https://www.instagram.com/getcaterplace/" target="_blank">
                <img src="../assets/images/icon-ig.png" width={40} className="img-fluid" alt="Icon" />
              </Link>
            </li>
            <li>
              <a href="mailto:support@caterplace.com">
                <img src="../assets/images/icon-mail.png" width={40} className="img-fluid" alt="Icon" />
              </a>
            </li>
          </ul>
        </div>
        <div className="copy-terms">
          <span>
            &copy; {moment().format(DATE_FORMATS.year)} Caterplace&reg;
            <br/>
            <a href="/terms-and-conditions">Terms & Conditions</a>
            <a href="/privacy-policy">Privacy Policy</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
